var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewOtherIncomeUser',{attrs:{"OI":_vm.OI,"countries":_vm.countries,"incomeTypes":_vm.incomeTypes},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }